import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => Promise<void> | void, interval: number) => {
  const savedCallback = useRef<(() => Promise<void> | void) | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let isMounted = true;

    const executeCallback = async () => {
      if (!isMounted || !savedCallback.current) return;

      try {
        const result = savedCallback.current();
        if (result instanceof Promise) {
          await result;
        }
      } catch (error) {
        console.error('Error in interval callback:', error);
      }

      if (isMounted) {
        timeoutRef.current = setTimeout(executeCallback, interval);
      }
    };

    void executeCallback();

    return () => {
      isMounted = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [interval]);
};
